var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style[`cc-popbox-confirm`]},[_c('IconConfirmAnimate',{attrs:{"size":70,"color":_vm.iconColor}}),_c('span',{staticClass:"font-medium",class:_vm.$style[`cc-popbox-confirm-info`]},[_vm._v(_vm._s(_vm.textInfo))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }